import React from 'react'
import '../../css/Faq.css';

const Faq = () => {
  return (
    <>
      <section className='faqbanner-section'>


        <div className='abttagline'>
          <h1>Frequently Asked Questions</h1>
          <h5 className='desk'>Everything You Need to Know, All in One Place</h5>
          <h5 className='mob'>Everything You Need to Know<br/>All in One Place</h5>
        </div>
      </section>

      <section className='faq-section faqbox'>
        <div className='container'>
          <div className='faqtags'>
            <ul>
              <li className='active'><h6><span>#</span>All</h6></li>
              <li><h6><span>#</span>Buy</h6></li>
              {/* <li><h6><span>#</span>Rent</h6></li> */}
              <li><h6><span>#</span>Plot</h6></li>
              <li><h6><span>#</span>Commercial</h6></li>
              {/* <li><h6><span>#</span>PG/Co-Living</h6></li> */}
            </ul>
          </div>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                  Why should I invest in JDA Approved Residential Plots in Kalwar Road Jaipur?
                </button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  Investing in JDA-approved plots gives investors peace of mind as they have been lawfully screened by authorities. Kalwar Road, Jaipur is rapidly developing, offering excellent connectivity, and is a prime location for future growth, making it an ideal investment for long-term value appreciation.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                  Are the residential plots on Kalwar Road Jaipur affordable?
                </button>
              </h2>
              <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  Yes, SiddhiAnanta Group provides some of the most reasonably priced JDA-approved residential plots. Their competitive pricing guarantees that purchasers receive excellent value for their money.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                  What are the benefits of purchasing residential plots on Kalwar Road?
                </button>
              </h2>
              <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">Kalwar Road provides a pleasant residential environment, future infrastructure, and easy access to key city locations. It’s a well-connected area that promises future development and growth, making it an attractive investment option.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingFour">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                  Can I construct a house on a JDA-approved residential plot on Kalwar Road?
                </button>
              </h2>
              <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">Yes, you can construct your home in accordance with local laws and regulations when you buy a site that has been approved by the JDA. The plot is ready for construction, offering you a hassle-free development experience.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingFive">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                  What is the process for buying a JDA Approved Residential Plot in Kalwar Road Jaipur?
                </button>
              </h2>
              <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">The process is simple and transparent. We help you with the registration, fees, and paperwork when you choose the plot. We ensure all legal processes are handled smoothly, making your buying experience easy and secure. </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Faq;